module.exports = __webpack_public_path__ + "img/exhibition.414cc69d.png";